import React from "react";
import { Input, Select } from "antd";
import { Store } from "../../../Types";

const { Option } = Select;

interface Props {
  searchInput: string;
  onSearchChange: (v: string) => void;
  stores: Store[];
  filterFromStore: string | null;
  onFromStoreChange: (v: string | null) => void;
  filterToStore: string | null;
  onToStoreChange: (v: string | null) => void;
}

export const StockTransferFilters: React.FC<Props> = ({
  searchInput,
  onSearchChange,
  stores,
  filterFromStore,
  onFromStoreChange,
  filterToStore,
  onToStoreChange,
}) => (
  <div className="flex flex-wrap items-center gap-2">
    <Input.Search
      placeholder="Search transfer no, note"
      allowClear
      value={searchInput}
      onChange={(e) => onSearchChange(e.target.value)}
      className="w-full sm:w-64"
    />
    <Select
      allowClear
      placeholder="Source Store"
      onChange={onFromStoreChange}
      value={filterFromStore}
      className="w-full sm:w-44"
    >
      {stores.map((s) => (
        <Option key={s.id} value={s.id}>
          {s.name}
        </Option>
      ))}
    </Select>
    <Select
      allowClear
      placeholder="Destination Store"
      onChange={onToStoreChange}
      value={filterToStore}
      className="w-full sm:w-44"
    >
      {stores.map((s) => (
        <Option key={s.id} value={s.id}>
          {s.name}
        </Option>
      ))}
    </Select>
  </div>
);
